var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "108.000000pt",
    height: "108.000000pt",
    viewBox: "0 0 108.000000 108.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,108.000000) scale(0.100000,-0.100000)",
    fill: "#FFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470 1060 c-19 -19 -20 -33 -20 -213 0 -231 -2 -227 103 -227 l67 0 0 -77 0 -78 78 78 77 77 133 0 c182 0 172 -14 172 229 l0 190 -26 20 c-26 20 -39 21 -295 21 -256 0 -270 -1 -289 -20z m555 -210 l0 -175 -135 -3 -135 -3 -42 -41 -43 -42 0 42 0 42 -85 0 -85 0 0 180 0 180 263 -2 262 -3 0 -175z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 871 c-16 -31 4 -63 37 -59 55 7 55 69 0 76 -18 2 -29 -3 -37 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 878 c-27 -27 -6 -68 35 -68 24 0 43 26 35 50 -10 30 -48 40 -70 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 876 c-6 -8 -10 -25 -8 -38 2 -18 10 -24 35 -26 28 -3 33 1 39 23 11 45 -37 75 -66 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 839 c-50 -36 -91 -114 -91 -175 0 -107 78 -256 209 -396 162 -174 352 -278 478 -263 132 16 229 158 156 227 -49 46 -187 128 -215 128 -17 0 -44 -15 -73 -40 -25 -22 -51 -40 -56 -40 -33 0 -115 65 -166 132 -60 78 -61 88 -13 143 25 29 40 56 40 73 0 26 -86 168 -133 220 -30 33 -83 30 -136 -9z m159 -110 c33 -50 60 -96 60 -101 0 -6 -18 -30 -40 -54 -23 -25 -40 -53 -40 -66 1 -93 184 -278 274 -278 15 0 44 17 71 40 25 22 50 40 55 40 20 0 190 -121 190 -136 0 -53 -89 -124 -156 -124 -206 0 -584 364 -611 587 -7 64 22 131 70 162 53 34 63 28 127 -70z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img_1.535f2df7d531bb52ac0bbef18c7ab135.svg";
export { ForwardRef as ReactComponent };